import script from "./CookieBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./CookieBanner.vue?vue&type=script&setup=true&lang=js"

import "./CookieBanner.vue?vue&type=style&index=0&id=192fce75&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-192fce75"]])

export default __exports__